import * as api from '../../api/login-client';
import { 
    POST_INICIAR_SESION,
    POST_CERRAR_SESION,
    POST_REFRESCAR_TOKEN,
    POST_ENVIAR_CODIGO
} from '../types';

export const iniciarSesionAction = (body) => ({
    type: POST_INICIAR_SESION,
    payload: api.postIniciarSesion(body)
});

export const cerrarSesionAction = () => ({
    type: POST_CERRAR_SESION,
    payload: api.postCerrarSesion()
});

export const refrescarTokenAction = (body) => ({
    type: POST_REFRESCAR_TOKEN,
    payload: api.postRefrescarToken(body)
});
export const enviaCodigoVerificacion = (body) => ({
    type: POST_ENVIAR_CODIGO,
    payload: api.postGestionaCambioPassword(body)
});
export const cambiarPassword = (body) => ({
    type: POST_ENVIAR_CODIGO,
    payload: api.postGestionaCambioPassword(body)
});
